<template>
    <div id="userCenter" :class="$root.isMob() ? 'mob' : ''" v-loading="loading">
        <div v-if="loading" class="loadingAlert">
            <el-alert
                title="加载中"
                description="正在加载数据,这可能需要一些时间,请稍后..."
                type="warning"
                center
                show-icon
                :closable="false">
            </el-alert>
        </div>
        <div class="left" v-show="!loading">
            <div class="title">
                <h2><i class="el-icon-s-custom icon"></i>用户中心</h2>
            </div>
            <div class="menu">
                <div :class="type == 1 ? 'item active' : 'item' " @click="changeType(1,$event.target)">基础资料</div>
                <div :class="type == 2 ? 'item active' : 'item' " @click="changeType(2,$event.target)">修改密码</div>
                <div :class="type == 3 ? 'item active' : 'item' " @click="changeType(3,$event.target)">修改邮箱</div>
                <div :class="type == 4 ? 'item active' : 'item' " @click="changeType(4,$event.target)">修改手机号</div>
            </div>
        </div>
        <div class="right" v-show="!loading">
            <div class="title">
                <h3>{{ itemTitle }}</h3>
            </div>
            <div class="content">
                <el-form v-if="userInfo && type == 1" ref="baseInfoForm" :model="baseInfoForm" label-width="80px">
                    <el-form-item label="头像">
                        <div class="sameRow">
                            <el-upload
                            class="avatar-uploader"
                            :action="API+'index.php/api/common/upload'"
                            :show-file-list="false"
                            :headers="{token:token}"
                            :on-success="uploadAvatar">
                                <div class="userAvatar">
                                    <img v-if="userAvatar != ''" :src="userAvatar" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </div>
                            </el-upload>
                        </div>                        
                    </el-form-item>
                    <el-form-item label="姓名：">
                        <el-input v-model="baseInfoForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Email：">
                        {{ baseInfoForm.email }}
                    </el-form-item>
                    <el-form-item label="手机号：">
                        {{ baseInfoForm.mobile }}
                    </el-form-item>
                    <el-form-item v-if="labInfo" label="我的单位">
                        <span v-if="labInfo">{{ labInfo.name }}<span class="lab-status">（{{ labInfo.status }}）</span></span>
                        <span v-else>暂无</span>
                    </el-form-item>

                    <el-form-item v-if="labInfo" label="学号：">
                        <span v-if="labInfo">{{ labInfo.student_id }}</span>
                        <span v-else>暂无</span>
                    </el-form-item>


                    <el-form-item v-if="labInfo == null" label="单位/学校：">
                        <el-input v-model="baseInfoForm.company"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="职业">
                        <template>
                            <span>{{ baseInfoForm.career_id_text }}</span>
                        </template>
                    </el-form-item>                     -->
                    <el-form-item>
                        <div class="buttonGroup">
                            <el-button type="primary" @click="saveInfo">保存</el-button>
                        </div>                        
                    </el-form-item>
                </el-form>

                <el-form v-if="type == 2" ref="passwordForm" :model="passwordForm">
                    <el-form-item label="旧密码">
                        <el-input type="password" show-password v-model="passwordForm.oldpassword"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input type="password" show-password v-model="passwordForm.newpassword"></el-input>
                    </el-form-item>
                    <el-form-item label="重复新密码">
                        <el-input type="password" show-password v-model="passwordForm.renewpassword"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="buttonGroup">
                            <el-button type="primary" @click="changePassword">修改</el-button>
                        </div>                        
                    </el-form-item>
                </el-form>

                <el-form v-if="type == 3" ref="emailForm" :model="emailForm">
                    <el-form-item label="新邮箱">
                        <el-input v-model="emailForm.email"></el-input>
                    </el-form-item>
                    <el-form-item>
                        验证码
                        <div class="sameRow">
                            <el-input v-model="emailForm.captcha"></el-input>
                            <div ref="getCaptcha" :class="getCaptchaClass" @click="sendCaptcha()">
                                {{ getCaptchaText }}
                            </div>
                        </div>                        
                    </el-form-item>
                    <el-form-item>
                        <div class="buttonGroup">
                            <el-button type="primary" @click="changeMail">修改</el-button>
                        </div>                        
                    </el-form-item>
                </el-form>
                
                <!-- 修改手机号 -->
                <el-form v-if="type == 4" ref="mobileFormRef" :model="mobileForm">
                    <el-form-item label="新手机号">
                        <el-input v-model="mobileForm.mobile"></el-input>
                    </el-form-item>
                    <el-form-item>
                        验证码
                        <div class="sameRow">
                            <el-input v-model="mobileForm.captcha"></el-input>
                            <div ref="getCaptchaMobile" :class="getCaptchaClass" @click="sendMobileCaptcha()">
                                {{ getCaptchaText }}
                            </div>
                        </div>                        
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input type="password" show-password v-model="mobileForm.newpassword"></el-input>
                    </el-form-item>
                    <el-form-item label="重复新密码">
                        <el-input type="password" show-password v-model="mobileForm.renewpassword"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="buttonGroup">
                            <el-button type="primary" @click="changeMobile">修改</el-button>
                        </div>                        
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'userCenter',
    watch:{
        "type"(){
            if(this.type == 3 || this.type == 4){
                this.getLastGetCaptchaTime();
            }
        }
    },
    data() {
        return {
            loading:true,
            baseInfoForm: {
                name: '',
                email: '',
                mobile: '',
                avatar: '',
                company: '',
                career_id: ''
            },
            labInfo: null,
            passwordForm:{
                oldpassword:'',
                newpassword:'',
                renewpassword:'',
            },
            emailForm:{
                email:'',
                captcha:''
            },
            mobileForm:{
                mobile:'',
                captcha:'',
                newpassword:'',
                renewpassword:''
            },
            API:window.config.api,
            token:"",
            userAvatar:"",
            userInfo:false,
            type:1,
            itemTitle:"基础信息",
            getCaptchaClass:"getCaptcha",
            getCaptchaText:"获取验证码",
            lastGetCaptchaTime:0,
            pageNum:5,
            logsList:[
                {
                    "name":"电镜名称",
                    "start":"2023-05-01",
                    "end":"2023-05-05",
                    "score":"100"
                },
            ],
        }
    },
    methods: {
        uploadAvatar(res){
            this.baseInfoForm.avatar = res.data.url;
            this.userAvatar = res.data.fullurl;
        },
        async getUserInfo(){
            this.userInfo = await this.$root.getUserInfo();
            this.baseInfoForm = this.userInfo;
            this.userAvatar = this.API + this.userInfo.avatar;
            
            // 处理机构信息
            if(this.userInfo.lab && this.userInfo.lab.name){
                this.labInfo = {
                    name: this.userInfo.lab.name,
                    status: this.userInfo.lab.status,
                    student_id: this.userInfo.student_id
                };
            } else {
                this.labInfo = null;
            }
            
            this.type = 1;
            this.loading = false;
        },
        changeType(type,self){
            this.type = type;
            this.itemTitle = self.innerText;
            self.classList.add('active');
            window.scrollTo(0,0);
        },
        async changePassword(){
            this.loading = true;
            let data = await this.$root.changePassword(this.passwordForm);
            this.loading = false;
            if(data){
                this.$emit('linkto','home');
            }
        },
       async saveInfo(){
            this.loading = true;
            let data = await this.$root.saveUserInfo(this.baseInfoForm);
            this.loading = false;
            if(data.code == 1){
                this.$notify({
                    type: 'success',
                    title: '通知',
                    message: '保存成功'
                });
            }
            else{
                this.$notify({
                    type: 'error',
                    title: '错误',
                    message: data.msg
                });
            }
        },
        getLastGetCaptchaTime(){            
            let time = window.localStorage.getItem("lastGetCaptchaTime");
            if(time){
                let now = Date.parse(new Date()) / 1000;
                if(now - time < 60){
                    this.lastGetCaptchaTime = time;
                    // 根据当前 tab 触发相应的验证码发送（邮箱或手机号）
                    if(this.type == 3){
                        this.sendCaptcha(true);
                    }
                    if(this.type == 4){
                        this.sendMobileCaptcha(true);
                    }
                }
            }
            else{
                this.lastGetCaptchaTime = 0;
            }
        },
        async sendMobileCaptcha(isSended=false){
            //检查getCaptchaClass是否包含disabled
            if(this.getCaptchaClass.indexOf("disabled") != -1){
                return;
            }
            //禁用getCaptcha按钮
            this.getCaptchaClass = this.getCaptchaClass + " disabled";
            if(!isSended){
                // 校验手机号是否填写
                if(!this.mobileForm.mobile || this.mobileForm.mobile.trim() === ""){
                    this.$notify({
                        type: 'warning',
                        title: '通知',
                        message: '请输入手机号'
                    });
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","").replace("disabled","");
                    return;
                }
                this.loading = true;
                try{
                    const payload = {
                        event: 'changemobile',
                        mobile: this.mobileForm.mobile
                    };
                    const res = await axios.post(window.config.api + 'index.php/api/sms/send', payload, {
                        headers: {
                            token: this.$root.token
                        }
                    });
                    let data = res.data;
                    this.loading = false;
                    if(data && data.code == 1){
                        let getTime = Date.parse(new Date()) / 1000;
                        this.lastGetCaptchaTime = getTime;
                        window.localStorage.setItem("lastGetCaptchaTime",getTime);
                        this.$notify({
                            type: 'success',
                            title: '通知',
                            message: data.msg
                        });
                    } else {
                        this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","").replace("disabled","");
                        if(data && data.msg){
                            this.$notify({
                                type: 'error',
                                title: '错误',
                                message: data.msg
                            });
                        }
                        return;
                    }
                } catch (err){
                    this.loading = false;
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","").replace("disabled","");
                    this.$notify({
                        type: 'error',
                        title: '错误',
                        message: '发送验证码失败'
                    });
                    return;
                }
            }
            this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
            let listen = setInterval(() => {
                let nowTime = Date.parse(new Date()) / 1000;
                if(nowTime - this.lastGetCaptchaTime >= 60){
                    this.getCaptchaText = "获取验证码";
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","");
                    this.getCaptchaClass = this.getCaptchaClass.replace("disabled","");
                    clearInterval(listen);
                }
                else{
                    this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
                }                
            }, 1000);
        },
        async changeMobile(){
            this.loading = true;
            // 校验
            if(!this.mobileForm.mobile || this.mobileForm.mobile.trim() === ""){
                this.$notify({ type: 'warning', title: '通知', message: '请输入新手机号' });
                this.loading = false;
                return;
            }
            if(!this.mobileForm.captcha || this.mobileForm.captcha.trim() === ""){
                this.$notify({ type: 'warning', title: '通知', message: '请输入验证码' });
                this.loading = false;
                return;
            }
            if(!this.mobileForm.newpassword || this.mobileForm.newpassword.trim() === ""){
                this.$notify({ type: 'warning', title: '通知', message: '请输入新密码' });
                this.loading = false;
                return;
            }
            if(this.mobileForm.newpassword !== this.mobileForm.renewpassword){
                this.$notify({ type: 'warning', title: '通知', message: '两次密码不一致' });
                this.loading = false;
                return;
            }
            try{
                const res = await axios({
                    method: "post",
                    url: window.config.api + "index.php/api/user/changemobile",
                    data: this.mobileForm,
                    headers: {
                        token: this.$root.token
                    }
                });
                let data = res.data;
                if(data && data.code == 1){
                    this.$notify({ type: 'success', title: '通知', message: '修改成功' });
                    this.getUserInfo();
                } else {
                    this.$notify({ type: 'error', title: '错误', message: data ? data.msg : '修改失败' });
                }
            } catch (err){
                this.$notify({ type: 'error', title: '错误', message: '修改失败' });
            }
            this.loading = false;
        },
        async sendCaptcha(isSended=false){
            //检查getCaptchaClass是否包含disabled
            if(this.getCaptchaClass.indexOf("disabled") != -1){
                return;
            }
            //禁用getCaptcha按钮
            this.getCaptchaClass = this.getCaptchaClass + " disabled";
            if(!isSended){
                this.loading = true;
                let data = await this.$root.sendCaptcha("changeemail",this.emailForm);
                this.loading = false;
                if(data.code == 1){
                    //获取当前时间戳
                    let getTime = Date.parse(new Date()) / 1000;
                    this.lastGetCaptchaTime = getTime;
                    window.localStorage.setItem("lastGetCaptchaTime",getTime);
                    this.$notify({
                        type: 'success',
                        title: '通知',
                        message: data.msg
                    });
                }
                else{
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","");
                    this.getCaptchaClass = this.getCaptchaClass.replace("disabled","");
                    return;
                }
            }
            this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
            let listen = setInterval(() => {
                let nowTime = Date.parse(new Date()) / 1000;
                if(nowTime - this.lastGetCaptchaTime >= 60){
                    this.getCaptchaText = "获取验证码";
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","");
                    this.getCaptchaClass = this.getCaptchaClass.replace("disabled","");
                    clearInterval(listen);
                }
                else{
                    this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
                }                
            }, 1000);
        },
        async changeMail(){
            this.loading = true;
            let data = await this.$root.changeMail(this.emailForm);
            if(data){
                if(data.code == 1){
                    this.$notify({
                        type: 'success',
                        title: '通知',
                        message: '修改成功'
                    });
                    this.loading = true;
                    this.getUserInfo();
                }
                else{
                    this.$notify({
                        type: 'error',
                        title: '错误',
                        message: data.msg
                    });
                }
            }
            this.loading = false;
        },
    },
    created() {
        this.token = this.$root.token;       
        this.getUserInfo(); 
    },
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/userCenter.scss">

</style>